export default __webpack_public_path__ + "static/media/paid-stamp.fb639b28.svg";